import { render } from "./SyfrusOffer.vue?vue&type=template&id=c284c4aa&scoped=true"
import script from "./SyfrusOffer.vue?vue&type=script&lang=js"
export * from "./SyfrusOffer.vue?vue&type=script&lang=js"

import "./SyfrusOffer.vue?vue&type=style&index=0&id=c284c4aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c284c4aa"]])

export default __exports__